export const LimitOrdersManagerAbi = [
  {
    anonymous: false,
    inputs: [
      { indexed: false, internalType: 'uint8', name: 'version', type: 'uint8' },
    ],
    name: 'Initialized',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
    ],
    name: 'Paused',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'address', name: 'from', type: 'address' },
      { indexed: true, internalType: 'address', name: 'to', type: 'address' },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
    ],
    name: 'Transfer',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
    ],
    name: 'Unpaused',
    type: 'event',
  },
  {
    inputs: [],
    name: 'LIMIT_ORDERS_CLOSER_ROLE',
    outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'LIMIT_ORDERS_MANAGER_ADMIN_ROLE',
    outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'uint256', name: 'orderTokenId_', type: 'uint256' },
      { internalType: 'uint256', name: 'amountIn_', type: 'uint256' },
    ],
    name: 'add',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'uint256', name: 'orderTokenId_', type: 'uint256' },
      { internalType: 'uint256', name: 'amountIn_', type: 'uint256' },
      {
        components: [
          {
            components: [
              { internalType: 'address', name: 'token', type: 'address' },
              { internalType: 'uint160', name: 'amount', type: 'uint160' },
              { internalType: 'uint48', name: 'expiration', type: 'uint48' },
              { internalType: 'uint48', name: 'nonce', type: 'uint48' },
            ],
            internalType: 'struct IAllowanceTransfer.PermitDetails',
            name: 'details',
            type: 'tuple',
          },
          { internalType: 'address', name: 'spender', type: 'address' },
          { internalType: 'uint256', name: 'sigDeadline', type: 'uint256' },
        ],
        internalType: 'struct IAllowanceTransfer.PermitSingle',
        name: 'permitSingleAllowanceData_',
        type: 'tuple',
      },
      { internalType: 'bytes', name: 'signature_', type: 'bytes' },
    ],
    name: 'addWithPermit2',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: 'owner_', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'baseURI',
    outputs: [{ internalType: 'string', name: '', type: 'string' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'int24', name: 'tick_', type: 'int24' }],
    name: 'canCloseLimitOrder',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'int24', name: 'tick_', type: 'int24' }],
    name: 'close',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'int24', name: 'tick_', type: 'int24' },
      { internalType: 'uint256', name: 'offset_', type: 'uint256' },
      { internalType: 'uint256', name: 'limit_', type: 'uint256' },
    ],
    name: 'closeClaims',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'int24', name: 'tick_', type: 'int24' },
      { internalType: 'uint256', name: 'amountIn_', type: 'uint256' },
    ],
    name: 'create',
    outputs: [
      { internalType: 'uint256', name: 'orderTokenId_', type: 'uint256' },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'int24', name: 'tick_', type: 'int24' },
      { internalType: 'uint256', name: 'amountIn_', type: 'uint256' },
      {
        components: [
          {
            components: [
              { internalType: 'address', name: 'token', type: 'address' },
              { internalType: 'uint160', name: 'amount', type: 'uint160' },
              { internalType: 'uint48', name: 'expiration', type: 'uint48' },
              { internalType: 'uint48', name: 'nonce', type: 'uint48' },
            ],
            internalType: 'struct IAllowanceTransfer.PermitDetails',
            name: 'details',
            type: 'tuple',
          },
          { internalType: 'address', name: 'spender', type: 'address' },
          { internalType: 'uint256', name: 'sigDeadline', type: 'uint256' },
        ],
        internalType: 'struct IAllowanceTransfer.PermitSingle',
        name: 'permitSingleAllowanceData_',
        type: 'tuple',
      },
      { internalType: 'bytes', name: 'signature_', type: 'bytes' },
    ],
    name: 'createWithPermit2',
    outputs: [
      { internalType: 'uint256', name: 'orderTokenId_', type: 'uint256' },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'uint256', name: 'orderTokenId_', type: 'uint256' },
    ],
    name: 'earlyExit',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'feeRecipientAddr',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'fissionUniswapV3Interactor',
    outputs: [
      {
        internalType: 'contract IFissionUniswapV3Interactor',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'fissionVault',
    outputs: [
      { internalType: 'contract IFissionVault', name: '', type: 'address' },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'fundOrderLimits',
    outputs: [
      { internalType: 'uint256', name: 'maxAmountPerOrder', type: 'uint256' },
      { internalType: 'uint256', name: 'maxAmountPerTick', type: 'uint256' },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'fundTokenAddr',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'getInjector',
    outputs: [{ internalType: 'address', name: 'injector_', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'uint256', name: 'orderId_', type: 'uint256' }],
    name: 'getOrder',
    outputs: [
      {
        components: [
          { internalType: 'address', name: 'owner', type: 'address' },
          { internalType: 'address', name: 'tokenToSell', type: 'address' },
          { internalType: 'uint256', name: 'amount', type: 'uint256' },
          { internalType: 'uint128', name: 'liquidity', type: 'uint128' },
          { internalType: 'int24', name: 'tick', type: 'int24' },
        ],
        internalType: 'struct ILimitOrdersManager.Order',
        name: '',
        type: 'tuple',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'int24', name: 'tick_', type: 'int24' }],
    name: 'getTickOrderAmount',
    outputs: [
      { internalType: 'uint256', name: 'amount', type: 'uint256' },
      { internalType: 'address', name: 'tokenToSell', type: 'address' },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'int24', name: 'tick_', type: 'int24' }],
    name: 'getTickOrderCount',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        components: [
          {
            components: [
              { internalType: 'string', name: 'name', type: 'string' },
              { internalType: 'string', name: 'symbol', type: 'string' },
              { internalType: 'string', name: 'baseUri', type: 'string' },
            ],
            internalType: 'struct ILimitOrdersManager.SBTInitParams',
            name: 'sbtInitParams',
            type: 'tuple',
          },
          { internalType: 'address', name: 'fundTokenAddr', type: 'address' },
          { internalType: 'address', name: 'usdcTokenAddr', type: 'address' },
          {
            internalType: 'address',
            name: 'feeRecipientAddr',
            type: 'address',
          },
          {
            internalType: 'uint256',
            name: 'maxOrdersCountPerUser',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'maxOrdersCountPerTick',
            type: 'uint256',
          },
          {
            components: [
              {
                internalType: 'uint256',
                name: 'maxAmountPerOrder',
                type: 'uint256',
              },
              {
                internalType: 'uint256',
                name: 'maxAmountPerTick',
                type: 'uint256',
              },
            ],
            internalType: 'struct ILimitOrdersManager.TokenOrderLimits',
            name: 'fundOrderLimits',
            type: 'tuple',
          },
          {
            components: [
              {
                internalType: 'uint256',
                name: 'maxAmountPerOrder',
                type: 'uint256',
              },
              {
                internalType: 'uint256',
                name: 'maxAmountPerTick',
                type: 'uint256',
              },
            ],
            internalType: 'struct ILimitOrdersManager.TokenOrderLimits',
            name: 'usdcOrderLimits',
            type: 'tuple',
          },
          { internalType: 'bool', name: 'requiredInsideVault', type: 'bool' },
        ],
        internalType: 'struct ILimitOrdersManager.LimitOrdersManagerInitParams',
        name: 'initParams_',
        type: 'tuple',
      },
    ],
    name: 'initialize',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'isRequiredToBeInsideVaultRange',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'maxOrdersCountPerTick',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'maxOrdersCountPerUser',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'name',
    outputs: [{ internalType: 'string', name: '', type: 'string' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'uint256', name: 'tokenId_', type: 'uint256' }],
    name: 'ownerOf',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'pause',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'paused',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'permissionManager',
    outputs: [
      {
        internalType: 'contract IPermissionManager',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'permit2',
    outputs: [{ internalType: 'contract IPermit2', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'positionManager',
    outputs: [
      {
        internalType: 'contract INonfungiblePositionManager',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'priceManager',
    outputs: [
      { internalType: 'contract IPriceManager', name: '', type: 'address' },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'string', name: 'baseURI_', type: 'string' }],
    name: 'setBaseURI',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'contractsRegistryAddr_',
        type: 'address',
      },
      { internalType: 'bytes', name: '', type: 'bytes' },
    ],
    name: 'setDependencies',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'feeRecipientAddr_', type: 'address' },
    ],
    name: 'setFeeRecipient',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: 'injector_', type: 'address' }],
    name: 'setInjector',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'maxOrdersCountPerUser_',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'maxOrdersCountPerTick_',
        type: 'uint256',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'maxAmountPerOrder',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'maxAmountPerTick',
            type: 'uint256',
          },
        ],
        internalType: 'struct ILimitOrdersManager.TokenOrderLimits',
        name: 'fundOrderLimits_',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'maxAmountPerOrder',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'maxAmountPerTick',
            type: 'uint256',
          },
        ],
        internalType: 'struct ILimitOrdersManager.TokenOrderLimits',
        name: 'usdcOrderLimits_',
        type: 'tuple',
      },
      { internalType: 'bool', name: 'requiredInsideVault_', type: 'bool' },
    ],
    name: 'setOrderLimits',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'bytes4', name: 'interfaceId_', type: 'bytes4' }],
    name: 'supportsInterface',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'symbol',
    outputs: [{ internalType: 'string', name: '', type: 'string' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'uint256', name: 'tokenId_', type: 'uint256' }],
    name: 'tokenExists',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'owner_', type: 'address' },
      { internalType: 'uint256', name: 'index_', type: 'uint256' },
    ],
    name: 'tokenOf',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    name: 'tokenURI',
    outputs: [{ internalType: 'string', name: '', type: 'string' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: 'owner_', type: 'address' }],
    name: 'tokensOf',
    outputs: [{ internalType: 'uint256[]', name: '', type: 'uint256[]' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'unpause',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'usdcOrderLimits',
    outputs: [
      { internalType: 'uint256', name: 'maxAmountPerOrder', type: 'uint256' },
      { internalType: 'uint256', name: 'maxAmountPerTick', type: 'uint256' },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'usdcTokenAddr',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
  },
] as const
